export default "__VITE_ASSET__hXmx7DNj__"